import React from 'react'

const Loader = (props) => {

    if(props.show){
        return(
            <div className="request-loader">
                <div className='css-loader'><div></div><div></div><div></div><div></div></div>
            </div>
        )
    }
    return null
}

export default Loader
